export const CURRENCY = "$";



// WEBPACK FOOTER //
// ./constants/CustomConstants.js